/**
 * Determines which language of box label directions to use.
 * May translate other label parts in the future as well.
 */
export enum LabelLanguage {
  ENGLISH = "ENGLISH",
  SPANISH = "SPANISH",
  MANDARIN = "MANDARIN",
}
